export { getFileSize } from '../BasicInfoDownload/BasicInfoDownload.utils'

export const getDescription = (description: string) => {
  const endsInAlphaNumeric = /[a-z0-9]$/i.test(description)
  return endsInAlphaNumeric ? `${description}.` : description
}
